import {Calibration} from '../../../Types/types';
import {noCacheFetcher} from '../../../utils/fetch';

//Store the calibrations
export function storeCalibration(newCalibration: Calibration | undefined, device: string, sensor: string): Promise<string> {
	return new Promise((resolve, reject) => {
		if (!device) return reject('No device id');
		const calibrationupdate = {
			deviceId: device,
			calibrationId: newCalibration === undefined ? null : newCalibration.id,
			sensor: sensor,
		};

		noCacheFetcher(process.env.REACT_APP_API_URL + `updatedevicecalibration`, {
			method: 'PUT',
			headers: new Headers({
				'Content-Type': 'application/json',
			}),
			body: JSON.stringify(calibrationupdate),
		}).then((res) => {
			if (res.status !== 200) {
				return reject('Error updating calibration');
			} else {
				return resolve('Calibration updated successfully');
			}
		});
	});
}
